<template>
  <div class="password-stock-page">
    <h2 style="text-align:center">{{params.title ? params.title : ''}}</h2>
    <editPasssordForm ref="editAccountPasssordForm"
                      @submitHandle="submitHandle"
                      @cancelHandle="cancelHandle" />
  </div>
</template>
<script>
import editPasssordForm from './components/editPasswordForm'
import tradeApi from '@/api/v2/trade'

export default {
  props: ['params'],
  components: { editPasssordForm },
  data () {
    return {

    }
  },
  methods: {
    resetForm () {
      this.$refs.editAccountPasssordForm.resetForm('form')
    },
    async submitHandle (form) {
      try {
        // let requestMap = new Map([
        //   ['SECURITIES_CASH', this.requestChangeStockPasswordApi],
        //   ['SECURITIES_MARGIN', this.requestChangeStockPasswordApi],
        //   ['FUTURES_MARGIN', this.requestChageFuturesPasswordApi],
        //   ['FUTURES_DAYTRADING_MARGIN', this.requestChageFuturesPasswordApi]
        // ])
        // let result = await requestMap.get(this.params.tradeAccountType)(form)
        let result = await this.requestChangeStockPasswordApi(form)
        console.log('submitHandle--result>>>>>>', result)
        this.$message({
          message: this.$t('common.changeSuccess'),
          type: 'success'
        })
      } catch (error) {
        console.log('error>>>>>', error)
        if (error.code) {
          this.$message.error(this.$t(`setting.${error.code}`))
        } else {
          this.$message.error(this.$t(`setting.7001`))
        }
      } finally {
        this.$refs.editAccountPasssordForm.resetForm('form')
        this.$refs.editAccountPasssordForm.clickable()
      }
    },
    // 修改密码
    async requestChangeStockPasswordApi (form) {
      try {
        let requestMap = new Map([
          ['SECURITIES_CASH', tradeApi.changeSecuritiesPwd], // 证券（现金）
          ['SECURITIES_MARGIN', tradeApi.changeSecuritiesMarginPwd], // 证券（保证金）
          ['FUTURES_MARGIN', tradeApi.changeFuturesMarginPwd], // 期货
          ['FUTURES_DAYTRADING_MARGIN', tradeApi.changeFuturesDayTradingMarginPwd], // 期货日内交易
          ['SECURITIES_AYERS_CASH', tradeApi.changeSecuritiesAyersCashPwd] // 全权委托(证券)
        ])
        let requestType = requestMap.get(this.params.tradeAccountType)
        let result = await requestType({
          tradeAccountNumber: this.params.tradeAccount,
          oldPassword: form.oldPassword,
          newPassword: form.newPassword,
          confirmPassword: form.confirmPassword
          // tradeAccountType: this.params.tradeAccountType
          // email: this.params.email,
          // language: this.params.language
        })
        return result
      } catch (e) {
        this.$message.error(e)
      }
    },
    // async requestChageFuturesPasswordApi (form) {
    //   try {
    //     let result = await tradeApi.changeSecuritiesPwd({
    //       tradeAccountNumber: this.params.tradeAccount,
    //       oldPassword: form.oldPassword,
    //       newPassword: form.newPassword,
    //       confirmPassword: form.confirmPassword
    //       // tradeAccountType: this.params.tradeAccountType
    //       // email: this.params.email,
    //       // language: this.params.language
    //     })
    //     console.log('requestChageFuturesPasswordApi--result>>>>>>>>>>>>>>>>>>', result)
    //     // let { msg, status } = result
    //     // console.log('msg, status', msg, status)
    //     // if (status === '0') {
    //     //   return result
    //     // } else {
    //     //   // eslint-disable-next-line no-throw-literal
    //     //   throw { code: status, msg: msg }
    //     // }
    //   } catch (error) {
    //     throw error
    //   }
    // },
    cancelHandle () {
      this.$emit('closeFun', false)
    }
  }
}
</script>
<style lang="scss">
</style>
